module.exports = __webpack_public_path__ + "media/views/about/images/icons/faq_2-cc67ddd6de53847c63a90365935f7762.svg";